import axios from "axios";
import { toast } from "react-toastify";
import {
  PROPERTY_DETAIL,
  PROPERTY_LIST,
  APPLY_PROPERTY,
  LIKE_PROPERTY,
  HIDDEN_PROPERTY,
  REPORT_PROPERTY,
  PROPERTY_WATCH,
  TENANT_LIST,
  ACTIVE_PROPERTY_LIST,GET_TENANT_TABLE,RENTER_LIST_DETAILS
} from "./types";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getPropertyList =
  (
    page,
    limit,
    search = "",
    room = "",
    zip = "",
    rentalPeriod = "",
    propertyType = "",
    minSize = "",
    maxSize = "",
    minPrice = "",
    maxPrice = "",
    day = "",
    included = "",
    navType = "",
    smoking = "",
    pets = "",
    gender = "",
    inhabitants = "",
    propertyPrice_sort =""
  ) =>
  async (dispatch) => {
    try {
      const res = await axios.get(
        `${PROXY}user/property/all?page=${page}&limit=${limit}&search=${search}&type=${navType}&zip_code=${zip}&rooms=${room}&rental_period=${rentalPeriod}&apartment_type=${propertyType}&startSize=${minSize}&endSize=${maxSize}&startPrice=${minPrice}&endPrice=${maxPrice}&includes=${included}&day_week_filter=${day}&smoking=${smoking}&pets=${pets}&gender=${gender}&inhabitants=${inhabitants}&propertyPrice_sort=${propertyPrice_sort}
        `
      );
      dispatch({
        type: PROPERTY_LIST,
        payload: res.data.result,
      });
      return res.data.result;
    } catch (err) {
      console.error(err);
      //   toast.error(err.response.data.message);
    }
  };

export const getPropertyDetail = (id) => async (dispatch) => {
  const res = await axios.get(`${PROXY}user/details/${id}`);
  dispatch({
    type: PROPERTY_DETAIL,
    payload: res.data.result[0],
  });
  return res.data.result[0];
};
export const getPropertyDetailOwner =
  (id, token = "", isReq) =>
  async (dispatch) => {
    const url = isReq
      ? `${PROXY}user/details/${id}/request`
      : `${PROXY}user/details/${id}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("property details", res.data.result[0]);
    dispatch({
      type: PROPERTY_DETAIL,
      payload: res.data.result[0],
    });
    return res.data.result[0];
  };

// apply property

export const applyProperty = (_id) => async (dispatch) => {
  // try {
  const res = await axios.post(`${PROXY}apply/property`, _id);
  dispatch(
    {
      type: APPLY_PROPERTY,
      payload: res.data.result,
    }
    // toast.success(res.data.message)
  );
  return res.data;
  // }
  // catch (err) {
  //   toast.error(err);
  // }
};

// like api start here

export const likeProperty = (property_id) => async (dispatch) => {
  // try {
  const res = await axios.post(`${PROXY}favourite`, property_id);
  dispatch(
    {
      type: LIKE_PROPERTY,
      payload: res.data.result,
    }
    // toast.success(res.data.message)
  );
  return res;
  // }
  // catch (err) {
  //   toast.error(err);
  // }
};

// unlike property start here

export const unlikeProperty = (id) => async (dispatch) => {
  // try {
  const res = await axios.delete(`${PROXY}favourite/${id}`);
  // toast.success(res.data.message);
  return res.data;
  // }
  //  catch (err) {
  //   toast.error(err);
  // }
};

// Print
export const PrintPropertyDetail = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}user/printpdf/${id}`);
    // toast.success(res.data.message);
    return res.data.result;
  } catch (err) {
    toast.error(err);
  }
};

// hidden property start here

export const hiddenProperty = (property_id) => async (dispatch) => {
  // try {
  const res = await axios.post(`${PROXY}hidden`, property_id);

  dispatch(
    {
      type: HIDDEN_PROPERTY,
      payload: res.data.result,
    }
    // toast.success(res.data.message)
  );
  return res;
  // }
  //  catch (err) {
  //   toast.error(err);
  // }
};

// report Incrrect details

export const reportProperty = (data) => async (dispatch) => {
  // try {
  const res = await axios.post(`${PROXY}report`, data);

  dispatch(
    {
      type: REPORT_PROPERTY,
      payload: res.data.result,
    }
    // toast.success(res.data.message)
  );
  return res;
};
//  catch (err) {
//   toast.error(err);
// }
// };

// Add Property Watch
export const addPropertyWatch = (data) => async () => {
  const res = await axios.post(`${PROXY}property-watch/add`, data);
  return res;
};

// Get Property Watch
export const getPropertyWatch = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}property-watch/get`);
  dispatch({
    type: PROPERTY_WATCH,
    payload: res.data.result,
  });
  return res.data.result;
};

// Add Tenant List
export const addTenantList = (data) => async () => {
  const res = await axios.post(`${PROXY}tenant-list/add`, data);
  return res;
};

// Get Tenant List
export const getTenantList = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}tenant-list/get`);
  dispatch({
    type: TENANT_LIST,
    payload: res.data.result,
  });
  return res.data.result;
};

export const editRentersList = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}tenant-list/edit-rental`, data);
  // toast.success(res.data.message);
  return res;
};

export const addRentersList = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}tenant-list/add-rental`, data);
  // toast.success(res.data.message);
  return res;
};

export const getRentalProfilePDF = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}tenant-list/generate-renter-info-pdf`);

  return res.data;
};


export const sendPDFWithEmail = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}tenant-list/send-mail-renter-pdf`);

  return res.data;
};

export const getActivePropertyList = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}setting/getall/web/sample`);
    dispatch({
      type: ACTIVE_PROPERTY_LIST,
      payload: res.data.result,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};
export const getTenantTable =
  (
    page,
    limit,
    order,
    sorting_field,
    nationality,
    age,
    zcode,
    bhk,
    familySize,
    paymentAmount,
    deliveryDate
  ) =>
  async (dispatch) => {
    try {
      const res = await axios.get(
        `${PROXY}tenant-list/user/tenant-list?page=${page}&limit=${limit}&sorting_order=${order}&sorting_field=${sorting_field}&nationality=${nationality}&age=${age}&zcode=${zcode}&bhk=${bhk}&familySize=${familySize}&paymentAmount=${paymentAmount}&deliveryDate=${deliveryDate}`
      );
      dispatch({
        type: GET_TENANT_TABLE,
        payload: res.data.result,
      });
      return res
    } catch (err) {
      console.error(err);
      //
    }
  };

  export const getRenterListDetail = (id) => async (dispatch) => {
    const res = await axios.get(`${PROXY}tenant-list/get-details/${id}`);
    dispatch({
      type: RENTER_LIST_DETAILS,
      payload: res.data.result,
    });
    return res.data.result;
  };
  export const updateRentersList = (data,id) => async (dispatch) => {
    const res = await axios.put(`${PROXY}tenant-list/edit-details/${id}`, data);
    // toast.success(res.data.message);
    return res;
  };